import { useRef, useCallback } from 'react';
import { createLatestRequestGuard } from '../utils/latestRequestGuard';

/**
 * Lightweight latest-wins guard for async request flows.
 * begin() returns request id, isCurrent(id) validates that response is still relevant.
 */
export function useLatestRequestGuard() {
  const guardRef = useRef(null);
  if (!guardRef.current) {
    guardRef.current = createLatestRequestGuard();
  }

  const begin = useCallback(() => guardRef.current.begin(), []);
  const isCurrent = useCallback((requestId) => guardRef.current.isCurrent(requestId), []);

  return { begin, isCurrent };
}
